import { AboutIntro, Attractions, BackgroundBanner } from "@/domains/components";
import {
    useGetDMaxCommon,
    type AboutDmaxInfoResponse,
    type AroundDmaxInfoResponse,
    type MainInfoDmaxResponse,
} from "@/shared/server";
import { Box, Center, Spinner, Text } from "@chakra-ui/react";

export const About = () => {
    const { data: main } = useGetDMaxCommon<MainInfoDmaxResponse>({ section: "main" });
    const { data: about } = useGetDMaxCommon<AboutDmaxInfoResponse>({ section: "about" });
    const { data: around } = useGetDMaxCommon<AroundDmaxInfoResponse>({ section: "around" });
    return main && about ? (
        <Box w="100%">
            <AboutIntro about={about} />
            <BackgroundBanner img_URL={main.imgList[0].img_URL} />
            <Attractions around={around} />
        </Box>
    ) : (
        <Center h="100vh" columnGap="8px">
            <Text>LOADING</Text>
            <Spinner />
        </Center>
    );
};
